require('./src/angular-environment');
module.exports = 'environment';


//////////////////
// WEBPACK FOOTER
// ./~/angular-environment/index.js
// module id = 135
// module chunks = 0